module.exports = __webpack_public_path__ + "img/37969-034.85cd1d24.jpg";